import React from "react";
import "./confirm.css";
import notvisited from "../../assets/icons/not-visited.png";
import notanswered from "../../assets/icons/not-answered.png";
import answered from "../../assets/icons/answered.png";
import notanswerreview from "../../assets/icons/not-answered-review.png";
import answerreview from "../../assets/icons/answered-review.png";
import Icon from "../../assets/icons/Icon.svg";
import { submitTestApi} from "../../services/saveAndNext";
import { connect } from "react-redux";
import saveAndNext  from "../../services/saveAndNext";

const Confirm = (props) => {
  const { type, sectionKey, setShow } = props;
  const submitTest = (isMannualSubmit = 0) => {
    setShow(false);
    submitTestApi(props, isMannualSubmit);
  };
  const getCurrentSectionTime = () => {
    if (!sectionKey || !props.state.subjects_data) return 0;
  
    const section = props.state.subjects_data.find((s) => {
      const key = `${s.subject_id}#${s.section_id}`;
      return key === sectionKey;
    });
  
    if (!section) {
      console.warn("Section not found for key:", sectionKey);
      return 0;
    }
  
    return section.remain_time || 0; // fallback if remain_time is undefined
  };
  console.log("sectionKey:", sectionKey);
  console.log("subjects_data:", props.state.subjects_data);
  
  console.log("time",props.currentTime)
  const submitSection = async () => {
    setShow(false);
    await saveAndNext({
      ...props,
      sectionKey,
      currentTime: props.currentTime, 
      isSectionSubmit: true,

    });

    const subjects = props.state.subjects_data || [];
    const index = subjects.findIndex(
      (s) => `${s.subject_id}#${s.section_id}` === sectionKey
    );
    if (index !== -1 && index + 1 < subjects.length) {
      const nextKey = `${subjects[index + 1].subject_id}#${subjects[index + 1].section_id}`;
      props.dispatch({ type: "SET_SELECTED_SECTION", selectedSection: nextKey });
      localStorage.setItem("selectedSection", nextKey);
    }
  };

  // helper: filter status only for section
  const getSectionStatuses = () => {
    if (type === "test" || !sectionKey) return props.state.questionstatus;
    const quesIds = (props.state.ques_data || [])
      .filter((q) => `${q.subject_id}#${q.section_id}` === sectionKey)
      .map((q) => q.ques_id);
    return props.state.questionstatus.filter((qs) =>
      quesIds.includes(Number(qs.ques_id))
    );
  };

  const statusList = getSectionStatuses();
  console.log("confirm")

  return (
    <div className="popup-box">
      <div className="modal-body-md">
        <div className="headerv">
          <img src={Icon} alt="icon" />
          <h2>
            {type === "test"
              ? "Are you sure you want to finish the test?"
              : "Are you sure you want to submit this section?"}
            <p>
              If you click on SUBMIT, you will not be able to change your{" "}
              {type === "test" ? "answers." : "answers in this section."}
            </p>
          </h2>
        </div>

        <div className="tt-8">
          <div>
            <img src={notvisited} /> Not Visited{" "}
            <span>{statusList.filter((s) => s.status_number == 1).length}</span>
          </div>
          <div>
            <img src={notanswered} /> Not Answered{" "}
            <span>{statusList.filter((s) => s.status_number == 2).length}</span>
          </div>
          <div>
            <img src={answered} /> Answered{" "}
            <span>{statusList.filter((s) => s.status_number == 4).length}</span>
          </div>
          <div>
            <img src={notanswerreview} /> Marked for Review{" "}
            <span>{statusList.filter((s) => s.status_number == 3).length}</span>
          </div>
          <div>
            <img src={answerreview} /> Answered & Marked for Review{" "}
            <span>{statusList.filter((s) => s.status_number == 5).length}</span>
          </div>
        </div>

        <div className="display">
          <button onClick={() => setShow(false)}>CANCEL</button>
          {type === "test" ? (
            (props.state.test_settings.is_test_submit_status=== 1)? (
              <button onClick={() => submitTest(1)}>SUBMIT</button>
            ) : (
              <div>
                <button disabled>SUBMIT</button>
                <p
                  style={{ fontSize: "12px", color: "red", marginTop: "5px" }}
                >
                  You cannot submit test before end time !
                </p>
              </div>
            )
          ) : (
            <button onClick={submitSection}>SUBMIT</button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ state: state });
export default connect(mapStateToProps)(Confirm);
